export default class ConfirmView {
    constructor() {
        this.closeBtn = document.querySelector('.js-confirm_close');
    }
}
